export default __webpack_public_path__ + "static/jellow-top-min-0ca87ddbc4f69736786eeef318168dc4.png";